import React from 'react'

function TextInput({ itemKey, name, formState, onChangeHandler, labelText, placeholder, className, type }) {
  return (
    <div className='mb-3 text-input'>
      {labelText && (
        <label htmlFor={name} className='form-label'>
          {labelText}<span className="text-danger">*</span>
        </label>
      )}
      <input
        type={type ? type : 'text'}
        className={`form-control ${className}`}
        id={name}
        name={name}
        placeholder={placeholder}
        value={itemKey.value !== undefined ? itemKey.value : itemKey}
        disabled={formState !== 'idle'}
        onChange={onChangeHandler}
        required={true}
        min={0}
      />
    </div>
  )
}

export default TextInput
